export default $axios => ({
  addItemToExistingOrder(payload, params = {}) {
    return $axios.post(`/api/cart/${payload.orderId}/items`, payload, {
      params
    });
  },

  createCart(payload) {
    return $axios.post(`/api/cart`, payload);
  },

  deleteItemFromOrder({ orderId, itemType, itemId }) {
    return $axios.delete(`/api/cart/${orderId}/${itemType}/${itemId}`);
  },

  async distribute(payload, params = {}) {
    const { itemId, itemType, orderId, partnerUser } = payload;
    await $axios.put(
      `/api/partnerUser/${partnerUser}/orders/${orderId}/${itemType}/${itemId}/distribution`,
      payload,
      {
        params
      }
    );
  },

  async distributeItems(payload, params = {}) {
    const { partnerUser } = payload;
    await $axios.post(
      `/api/partnerUser/${partnerUser}/distributions`,
      payload,
      {
        params
      }
    );
  },

  getActiveOrder({ orderId }) {
    return $axios.get(`/api/cart/${orderId}`);
  },

  getOrder({ partnerUserId, orderId }) {
    return $axios.get(
      `/api/partnerUser/${partnerUserId}/orders/${orderId}`
    );
  },

  getOrderHistory({ partnerUserId, params = {} }) {
    return $axios.get(`/api/partnerUser/${partnerUserId}/orders`, {
      params
    });
  },

  getPoints({ partnerUser, params = {} }) {
    return $axios.get(`/api/partnerUser/${partnerUser}/points/current`, {
      params
    });
  },

  getPointsHistory({ partnerUser, params = {} }) {
    return $axios.get(`/api/partnerUser/${partnerUser}/points/history`, {
      params
    });
  },

  async keepOrderAlive(payload, params = {}) {
    await $axios.put(
      `/api/cart/${payload.orderId}/keepOrderAlive`,
      payload,
      {
        params
      }
    );
  },

  orderComplete(payload, params = {}) {
    return $axios.put(`/api/cart/${payload.orderId}/complete`, payload, {
      params
    });
  },

  orderExpired({ orderId, itemType, itemId }) {
    return $axios.delete(`/api/cart/${orderId}/${itemType}/${itemId}`);
  },

  async updateOrder(payload, params = {}) {
    return $axios.put(`/api/cart/${payload.orderId}`, payload, {
      params
    });
  },

  async updateOrderItems(payload, params = {}) {
    return $axios.put(
      `/api/cart/${payload.orderId}/${payload.itemType}/${payload.itemId}`,
      payload,
      {
        params
      }
    );
  }
});
